export default __webpack_public_path__ + "static/media/main_pic.27f02f56.jpg";